import { toast } from "sonner";
import { t } from "@/i18n";

// Confirmación breve de guardado local. Fase 1: todo se persiste en localStorage
// de inmediato; este toast solo confirma al usuario que el cambio quedó guardado.
export const notifySaved = () => toast.success(t.common.saved, { duration: 1400 });
